<template>
  <div>
    <el-dialog :visible.sync="visible" @closed="closed" :close-on-click-modal="false">
      <div class="content">
        <div class="desc">
          <div class="title">起诉费计算器</div>
          <div class="last">根据案件类型及相关标的计算诉讼费</div>
        </div>
        <div class="form">
          <el-form :model="form" ref="form" @submit.native.prevent label-position="top">
            <el-form-item
              prop="type"
              label="案件类型"
              :rules="{ required: true, message: '请选择案件类型' }"
            >
              <select
                class="el-style-select"
                v-model="form.type"
                placeholder="请选择案件类型"
                style="width: 100%"
                :popper-append-to-body="false"
              >
                <option
                  v-for="item in typeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  {{ item.label }}
                </option>
              </select>
            </el-form-item>
            <el-form-item
              label="是否涉及财产"
              prop="involvingProperty"
              :rules="{ required: true, message: '请选择是否涉及财产' }"
            >
              <el-radio-group
                v-model="form.involvingProperty"
                :disabled="![2, 5].includes(form.type)"
              >
                <el-radio label="TRUE">是</el-radio>
                <el-radio label="FALSE">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="诉讼标的/元"
              prop="price"
              :rules="{ required: true, message: '请输入诉讼标的' }"
            >
              <el-input
                v-model="form.price"
                placeholder="请输入诉讼标的"
                style="width: 100%"
                type="number"
                :min="0"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn">
          <el-button class="button" @click="onReset">重置</el-button>
          <el-button
            class="button"
            type="primary"
            @click="onSubmin"
            :disabled="form.price <= 0"
            >计算</el-button
          >
        </div>
        <div class="result">
          <div class="top">
            <div class="calculationResults">计算结果</div>
            <div class="copy" @click="copyToClipboard">
              <i class="el-icon-document-copy"></i>
              复制
            </div>
          </div>
          <div class="bottom">
            <div class="price">
              <span v-show="renderPrice.min">{{ renderPrice.min }}</span>
              <span v-show="renderPrice.max">~{{ renderPrice.max }}</span>
              <span v-show="!renderPrice.min">--</span>
            </div>
            <div class="chinesePrices">受理费/元</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { typeList, calculatorFn } from "./api.js";

export default {
  components: {},
  data() {
    return {
      visible: false,
      form: {
        type: 1,
        price: 0,
        involvingProperty: "FALSE",
      },
      typeList,
      renderPrice: {
        min: 0,
        max: 0,
      },
    };
  },
  watch: {
    "form.type"(val) {
      if (![2, 5].includes(val)) {
        this.form.involvingProperty = "FALSE";
      } else {
        this.form.involvingProperty = "TRUE";
      }
    },
  },
  created() {},
  computed: {},
  methods: {
    onReset() {
      this.renderPrice = {
        min: 0,
        max: 0,
      };
      this.form = {
        type: 1,
        price: 0,
        involvingProperty: "TRUE",
      };
    },
    closed() {
      this.onReset();
    },
    onShow() {
      this.visible = true;
    },
    onSubmin() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.onCount();
        } else {
          return false;
        }
      });
    },
    // 计算
    async onCount() {
      const data = await calculatorFn(this.form);
      this.renderPrice = data;
      console.log(data);
    },
    async copyToClipboard() {
      const { min, max } = this.renderPrice;
      if (min === 0 && max === 0) return;
      if (navigator.clipboard) {
        try {
          let text = "";
          if (max) {
            text = `计算结果：${min}~${max},受理费：${min}~${max}元`;
          } else {
            text = `计算结果：${min},受理费：${min}元`;
          }
          await navigator.clipboard.writeText(text);
          this.$message({
            type: "success",
            message: "已复制到剪贴板",
          });
          console.log("已复制到剪贴板");
        } catch (err) {
          console.error("复制到剪贴板出错:", err);
        }
      } else {
        this.$message({
          type: "warning",
          message: "您的浏览器不支持此复制功能",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  .desc {
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    height: 83px;
    justify-content: center;
    .title {
      font-size: 18px;
      font-weight: 500;
      color: #262626;
    }
    .last {
      margin-top: 4px;
      font-size: 14px;
      font-weight: 350;
      color: #666666;
    }
  }
  .form {
    padding: 0 16px;
    @include formStyle;
  }
  .btn {
    padding: 16px;
    display: flex;
    height: 64px;
    align-items: center;
  }
  .result {
    margin: 16px;
    margin-top: 10px;
    background: #f5f7fa;
    padding: 14px;
    padding-bottom: 0;
    border-radius: 6px;
    .top {
      display: flex;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .calculationResults {
        font-size: 16px;
        font-weight: 500;
        color: #262626;
      }
      .copy {
        color: #0062ff;
        cursor: pointer;
      }
    }
    .bottom {
      display: flex;
      flex-direction: column;
      .price {
        font-size: 30px;
        font-weight: 500;
        color: #262626;
        line-height: 78px;
        border-bottom: 1px solid #eee;
      }
      .chinesePrices {
        font-size: 12px;
        color: #666666;
        line-height: 40px;
      }
    }
  }
}
::v-deep {
  .el-input {
    padding: 0;
    &__inner::-webkit-inner-spin-button,
    &__inner::-webkit-outer-spin-button {
      -webkit-appearance: none;
      appearance: none;
      margin: 0;
    }
    &__inner[type="number"] {
      -moz-appearance: textfield;
    }
  }
}

.el-style-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  width: 100%;
  height: 34px;
  line-height: 34px;
  padding: 0 30px 0 12px;

  font-size: 14px;
  color: #606266;
  background-color: #fff;

  border: 1px solid #dcdfe6;
  border-radius: 4px;

  background-image: url("data:image/svg+xml;utf8,<svg fill='%23999' height='20' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px 16px;

  transition: border-color 0.2s ease-in-out;
}

.el-style-select:hover {
  border-color: #c0c4cc;
}

.el-style-select:focus {
  border-color: #0062ff;
  outline: none;
}

.el-style-select:disabled {
  background-color: #f5f7fa;
  color: #c0c4cc;
  cursor: not-allowed;
}
</style>
